<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<lms-loco-update-int-usage *ngIf="tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded'"></lms-loco-update-int-usage>
<div class="clear"></div>
<div class="top-actions" id="top-actions">
    <div class="loco-container" [ngClass]='(!locoIcon && (tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === "loaded" || tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === "refresh")) ? "locoIconLoading" : ""'>
        <!-- <img class="loco-na-icon" *ngIf="tab?.subTypeDetail[tab.subType.toLowerCase()]?.status !== 'loaded'" [src]="locoNaIcon" /> -->
        <span *ngIf="tab?.subTypeDetail[tab.subType.toLowerCase()]?.status !== 'loaded'" class="loco-na-icon">NA</span>
        <lms-loco-svg [loco]='locoIcon' *ngIf="iconIdentified && locoIcon && tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded'" [isDefaultLocoIcon]="tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded'? false : true" [svgWidthClass]="'loco-top-svg'"></lms-loco-svg>
        <span *ngIf='(!iconIdentified && (tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === "loaded" || tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === "refresh"))' class="locoIcon-warning">{{tab.tabSearchParameter.searchText}}</span>
    </div>

    <lms-header-sub-types [subTypes]="subTypes" [tab]="tab" [tabIndex]='tabLevel'></lms-header-sub-types>
    <div class="top-buttons-group">
        <button type="button" class="{{tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded' && tab.mode === 'view' && (user && user.isUserManagerOrDirector) ? 'p-button-secondary' : 'p-button-disabled'}}" disabled="{{tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded' && tab.mode === 'view' && (user && user.isUserManagerOrDirector) ? '' : 'disabled'}}"
            tabindex="{{tabLevel + 11}}" (click)="editLocomotiveDetails()"> <span class="fa fa-pencil"></span> Edit</button>
        <button type="button" class="{{tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded' && tab.mode === 'edit' && (user && user.isUserManagerOrDirector) ? 'p-button-secondary' : 'p-button-disabled'}}" disabled="{{tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded' && tab.mode === 'edit'&& (user && user.isUserManagerOrDirector) ? '' : 'disabled'}}"
            tabindex="{{tabLevel + 13}}" (click)="cancelLocomotiveEdit()"> <span class="fa fa-ban"></span> Cancel</button>
        <button type="submit" #locoSubmitBtn id='locoDataSubmitButton' class="{{tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded' &&tab.mode === 'edit' && (user && user.isUserManagerOrDirector) &&  locoEditForm.valid ? 'p-button-primary' : 'p-button-disabled'}}"
            disabled="{{tab?.subTypeDetail[tab.subType.toLowerCase()]?.status === 'loaded' &&tab.mode === 'edit' && (user && user.isUserManagerOrDirector) && locoEditForm.valid ? '' : 'disabled'}}" tabindex="{{tabLevel + 15}}" (keyup.spacebar)='locoSubmitBtn.click();'> <span class="csx csx-common_trash"></span> Submit</button>

    </div>
    <div class="other-actions">
        <p-splitButton [disabled]="tab && 'edit'===tab.mode || (user && !user.isUserManagerOrDirector)" styleClass="split-button-ui" label="Other Actions" [model]="otherOptions" tabindex="{{tabLevel + 17}}">
        </p-splitButton>
    </div>
</div>
<!-- START Plan Locomotive Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="locoPlanPopup" (onHide)='cancelOperation("planLocomotive");' [(visible)]="planLocomotive" [resizable]="false" [draggable]="false" class="{{errorDialog? 'terminal-ui-popups plan-locomotive error-dialog':'terminal-ui-popups plan-locomotive'}}"
    header="{{popupErrorMessage}}" modal="true" closeOnEscape="true" (onShow)='setPageMode("planSubmitPopup"); setFocusToGivenElement("locoDataPlanTrnInput", "5")'>
    <div *ngIf='planLocomotive'>
        <div class="plan-to">
            <div class="plan-to-dropdown">
                <label>{{configData && configData.yardLocalLabel.planTo}}</label>
                <p-dropdown [panelStyleClass]="'dialog-dropdown'" class="pull-left" [tabindex]="popUpTabIndex+1" [options]="planOptions" (onChange)="changePlanOptions('Plan Locomotive')" [(ngModel)]='locoPlannedTo'></p-dropdown>
            </div>

            <div class="plan-to-input" *ngIf="locoPlannedTo === 'train'">
                <label>{{configData && configData.yardLocalLabel.train}}</label>
                <span class="select-train-terminal">
				<input id="locoDataPlanTrnInput" type="text" tabindex="{{popUpTabIndex+2}}" placeholder="Train ID" spellcheck="false"  class="{{isAddTrainError ? 'p-inputfield train-placeholder p-inputfield-error' : 'p-inputfield train-placeholder'}}"  name="searchTextTrain" [(ngModel)]="searchTextTrain" required minlength="6" maxlength="6">
				<div class="color-red" *ngIf='isAddTrainError'>{{configData && configData.messages.planInvalidTrainId}}</div>
				</span>
            </div>

            <div class="plan-to-input" [hidden]="locoPlannedTo === 'train'">
                <label>{{configData && configData.yardLocalLabel.terminal}}
                </label>
                <span class="select-train-terminal">
					<lms-autocomplete [tabindex]="popUpTabIndex+2" styleclass="p-autocomplete top-actions-autocomplete" [inputId]='"locoDataTerminalSuggstInput"' spellcheck="false" [(ngModel)]="searchTextTerminal" [ngClass]="'terminal-autocomplete'" placeholder="Mnemonic" [suggestions]="filteredResults" (completeMethod)="autoCompleteForTerminal($event)"
                        [minLength]="2" (onSelect)="selectValueFromAutoComplete(searchTextTerminal, 'foreignRailRoad')" inputStyleClass="{{searchPlanTextTerminalError ? 'p-inputfield-error' : ''}}" [maxlength]="6" (keydown.space)='$event.stopPropagation();'
                        (keydown.spacebar)='$event.stopPropagation();' (keyup.space)='$event.stopPropagation();' (keyup.spacebar)='$event.stopPropagation();'></lms-autocomplete>
                    <font class="update-terminal-text" *ngIf="locoPlannedTo ==='terminal'"> Enter terminal.  Press TAB to evaluate servicing capability.</font>
                    <div class="color-red clearfix" *ngIf='searchPlanTextTerminalError'> {{configData && configData.messages.planInvalidTerminal}} </div>
				</span>
            </div>

            <div class="plan-to-input frr-road" [hidden]="locoPlannedTo !=='foreignRailRoad'">
                <label>Road</label>
                <span class="select-train-terminal">
				<p-dropdown [panelStyleClass]="'dialog-dropdown'" [filter]="true" [options]="selectedRoadValues" [tabindex]="popUpTabIndex+3" disabled="{{!selectedTerminalRoad}}" styleClass="{{selectedTerminalRoadError ? 'p-inputfield-error pull-left p-dropdown' : 'pull-left p-dropdown'}}" ngModel name='roadValue' [(ngModel)]='selectedTerminalRoad'>
					<ng-template let-roadValue pTemplate="roadValue">
						<div class="p-helper-clearfix">
						<div> {{roadValue.label}} </div>
						</div>
				</ng-template>
				</p-dropdown>
				<div class="color-red clearfix" *ngIf='selectedTerminalRoadError'> {{configData.messages.planInvalidRoad}} </div>
				</span>

            </div>

            <div class="terminal-handling-plan" [hidden]="locoPlannedTo === 'foreignRailRoad'">
                <h2>{{configData && configData.yardLocalLabel.terminalHandlingPlan}}</h2>
                <ul>
                    <li *ngIf="!isValidThpSelection">
                        <p-radioButton [tabindex]="popUpTabIndex+4" name="thpPlan1" value="S" label="{{configData && configData.yardLocalLabel.serviceCtrShop}}" [(ngModel)]="thpPlan"></p-radioButton>
                    </li>
                    <li>
                        <p-radioButton [tabindex]="popUpTabIndex+5" name="thpPlan1" value="T" label="{{configData && configData.yardLocalLabel.truckFueling}}" [(ngModel)]="thpPlan"></p-radioButton>
                    </li>
                    <li>
                        <p-radioButton [tabindex]="popUpTabIndex+6" name="thpPlan1" value="M" label="{{configData && configData.yardLocalLabel.mainTrack}}" [(ngModel)]="thpPlan"></p-radioButton>
                    </li>
                    <li *ngIf="user && user.isUserManagerOrDirector">
                        <p-radioButton [tabindex]="popUpTabIndex+7" name="thpPlan1" value="X" label="{{configData && configData.yardLocalLabel.toStorage}}" [(ngModel)]="thpPlan"></p-radioButton>
                    </li>
                </ul>
                <div>

                </div>
            </div>
            <div class="clear"></div>
        </div>

        <div class="items-to-plan" *ngIf="locoPlannedTo !=='train'">
            <h2>{{configData && configData.yardLocalLabel.locomotives}} (1)</h2>
            <ul>
                <li>
                    {{locoSVG && appUtilityService.UIformatLocomotiveId(locoSVG.locomotiveIdentifier)}}
                </li>
            </ul>
        </div>
        <div class="items-to-plan" *ngIf="locoPlannedTo ==='train'">

            <div class="plan-loco-table">
                <div class="table">
                    <div class="table-header">
                        <div class="columns-loco">{{configData && configData.yardLocalLabel.locomotive}} (1)</div>
                        <div class="columns-iu">{{configData && configData.yardLocalLabel.intendedUsage}} </div>
                        <div class="columns-reason">{{configData && configData.yardLocalLabel.reason}} </div>
                        <div class="columns-notes"> </div>
                    </div>
                    <div class="table-body">
                        <div class="table-row">
                            <lms-intended-usage [indexPosition]='0' [tabLevel]='popUpTabIndex + 10' [locoData]='locoSVG'></lms-intended-usage>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="dialog-buttons">

            <span class="pull-right">

	<button class="p-button-secondary" tabindex='{{popUpTabIndex+21}}' (click)="cancelOperation('planLocomotive')">{{configData && configData.yardLocalLabel.cancel}}</button>

			<button class="p-button-primary" tabindex="{{popUpTabIndex+22}}" id="planSubmitPopup" (click)="submitOperation('planLocomotive')">{{configData && configData.yardLocalLabel.submit}}</button>
			</span>
        </div>
    </div>
</p-dialog>
<!-- END Plan Locomotive Popup -->
<!-- Start Update Terminal Handling Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" [resizable]="false" [draggable]="false" class="{{errorDialog?'terminal-ui-popups plan-locomotive error-dialog':'terminal-ui-popups plan-locomotive'}}" header="{{popupErrorMessage}}" [(visible)]="terminalPlan" modal="true" (onHide)='cancelOperation("terminalPlan");'
    closeOnEscape="true" id="locoUthPopup" (onShow)="focusOnDialog('locoUthPopup')">
    <div class="plan-locomotive-container" *ngIf='terminalPlan'>
        <div class="loco-to-plan">
            <span class="loco-icon-plan">{{locoSVG && appUtilityService.UIformatLocomotiveId(locoSVG.locomotiveIdentifier)}}</span>
            <br>
            <p class="or">On</p>
            <label><strong>Terminal</strong></label>
            <input type="text" spellcheck="false" disabled="true" value="{{locoSVG.thpTerminal}}" class="p-inputfield" tabindex="{{popUpTabIndex+1}}">
            <p style='padding:5px 0 0 65px;'><span>{{getTerminalCityState(locoSVG.thpTerminal)}}</span>
            </p>
        </div>
        <div class="place-to-plan">
            <div class="plan-locoto-train">
                <div class="shop-fuel-storage">
                    <h3>Terminal Handling Plan</h3>
                    <ul>
                        <li *ngIf="appUtilityService.isValidThpSelection(locoSVG.thpTerminal)">
                            <p-radioButton name="thpPlan3" value='S' label="Service Ctr / Shop" [(ngModel)]="thpPlan" [tabindex]="popUpTabIndex+2"></p-radioButton>
                        </li>
                        <li>
                            <p-radioButton name="thpPlan3" value='T' label="Truck Fueling" [(ngModel)]="thpPlan" [tabindex]="popUpTabIndex+3"></p-radioButton>
                        </li>

                        <li>
                            <p-radioButton name="thpPlan3" value='M' label="Main Track" [(ngModel)]="thpPlan" [tabindex]="popUpTabIndex+4"></p-radioButton>
                        </li>
                        <li *ngIf="user && user.isUserManagerOrDirector">
                            <p-radioButton name="thpPlan3" value='X' label="To Storage" [(ngModel)]="thpPlan" [tabindex]="popUpTabIndex+5"></p-radioButton>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
    <div class="dialog-buttons" *ngIf='terminalPlan'>
        <span class="pull-right">
					<button type="button" class="p-button-secondary"  (click)="cancelOperation('terminalPlan')" tabindex="{{popUpTabIndex+6}}">Cancel</button>
					<button type="submit" id='terminalPlanLocoData' disabled="{{!thpPlan?'disable':''}}" class="{{!thpPlan?'p-button-disabled':'p-button-primary'}}" (click)="submitThpOperation()" tabindex="{{popUpTabIndex+7}}">Submit</button>
		</span>
    </div>
</p-dialog>
<!-- END Update Terminal Handling Popup -->
<!-- Start Bring Online Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="locoBringOnlinePopup" (onHide)='cancelOperation("bringOnline");' [(visible)]="bringOnline" [resizable]="false" [draggable]="false" class="{{errorDialog? 'terminal-ui-popups plan-locomotive error-dialog':'terminal-ui-popups plan-locomotive'}}"
    header="{{popupErrorMessage}}" modal="true" closeOnEscape="true" (onShow)="setPageMode('bringOnlineLocoData');setFocusToGivenElement('bringOnlineTrnInput')">
    <div *ngIf='bringOnline'>
        <div class="plan-to">
            <div class="plan-to-dropdown">
                <label>{{configData && configData.yardLocalLabel.planTo}}</label>
                <p-dropdown [panelStyleClass]="'dialog-dropdown'" class="pull-left" [tabindex]="popUpTabIndex+1" [options]="planOptions" (onChange)="changePlanOptions('Bring Online')" [(ngModel)]='locoPlannedTo'></p-dropdown>
            </div>

            <div class="plan-to-input" *ngIf="locoPlannedTo === 'train'">
                <label>{{configData && configData.yardLocalLabel.train}}</label>
                <span class="select-train-terminal">
				<input id="bringOnlineTrnInput" type="text" tabindex="{{popUpTabIndex+2}}" placeholder="Train ID" spellcheck="false"  class="{{isAddTrainError ? 'p-inputfield train-placeholder p-inputfield-error' : 'p-inputfield train-placeholder'}}"  name="searchTextTrain" [(ngModel)]="searchTextTrain" required minlength="6" maxlength="6">
				<div class="color-red" *ngIf='isAddTrainError'>{{configData && configData.messages.planInvalidTrainId}}</div>
				</span>
            </div>

            <div class="plan-to-input" [hidden]="locoPlannedTo === 'train'">
                <label>{{configData && configData.yardLocalLabel.terminal}}</label>
                <span class="select-train-terminal">
					<lms-autocomplete [tabindex]="popUpTabIndex+2" styleclass="p-autocomplete" id="terminalSuggestSearch" spellcheck="false" [(ngModel)]="searchTextTerminal" [ngClass]="'terminal-autocomplete'" placeholder="Mnemonic" [suggestions]="filteredResults" (completeMethod)="autoCompleteForTerminal($event)"
                        [minLength]="2" (onSelect)="selectValueFromAutoComplete(searchTextTerminal)" inputStyleClass="{{searchPlanTextTerminalError ? 'p-inputfield-error' : ''}}" [maxlength]="6" (keydown.space)='$event.stopPropagation();'
                        (keydown.spacebar)='$event.stopPropagation();' (keyup.space)='$event.stopPropagation();' (keyup.spacebar)='$event.stopPropagation();'></lms-autocomplete>
                    <div class="color-red clearfix" *ngIf='searchPlanTextTerminalError'> {{configData && configData.messages.planInvalidTerminal}} </div>
				</span>
            </div>

            <div class="terminal-handling-plan">
                <h2>{{configData && configData.yardLocalLabel.terminalHandlingPlan}}</h2>
                <ul>
                    <li>
                        <p-radioButton [tabindex]="popUpTabIndex+3" name="thpPlan4" value="S" label="{{configData && configData.yardLocalLabel.serviceCtrShop}}" [(ngModel)]="thpPlan"></p-radioButton>
                    </li>
                    <li>
                        <p-radioButton [tabindex]="popUpTabIndex+4" name="thpPlan4" value="T" label="{{configData && configData.yardLocalLabel.truckFueling}}" [(ngModel)]="thpPlan"></p-radioButton>
                    </li>
                    <li>
                        <p-radioButton [tabindex]="popUpTabIndex+5" name="thpPlan4" value="M" label="{{configData && configData.yardLocalLabel.mainTrack}}" [(ngModel)]="thpPlan"></p-radioButton>
                    </li>
                    <li *ngIf="user && user.isUserManagerOrDirector">
                        <p-radioButton [tabindex]="popUpTabIndex+6" name="thpPlan4" value="X" label="{{configData && configData.yardLocalLabel.toStorage}}" [(ngModel)]="thpPlan"></p-radioButton>
                    </li>
                </ul>
                <div>

                </div>
            </div>
            <div class="clear"></div>
        </div>

        <div class="items-to-plan" *ngIf="locoPlannedTo !=='train'">
            <h2>{{configData && configData.yardLocalLabel.locomotives}} (1)</h2>
            <ul>
                <li>
                    {{locoSVG && appUtilityService.UIformatLocomotiveId(locoSVG.locomotiveIdentifier)}}
                </li>
            </ul>
        </div>
        <div class="items-to-plan" *ngIf="locoPlannedTo ==='train'">

            <div class="plan-loco-table">
                <div class="table">
                    <div class="table-header">
                        <div class="columns-loco">{{configData && configData.yardLocalLabel.locomotive}} (1)</div>
                        <div class="columns-iu">{{configData && configData.yardLocalLabel.intendedUsage}} </div>
                        <div class="columns-reason">{{configData && configData.yardLocalLabel.reason}} </div>
                        <div class="columns-notes"> </div>
                    </div>
                    <div class="table-body">
                        <div class="table-row">
                            <lms-intended-usage [indexPosition]='0' [tabLevel]='popUpTabIndex + 10' [locoData]='locoSVG'></lms-intended-usage>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="dialog-buttons" *ngIf='bringOnline'>

            <span class="pull-right">

	<button class="p-button-secondary" tabindex='{{popUpTabIndex+21}}' (click)='cancelOperation("bringOnline")'>{{configData && configData.yardLocalLabel.cancel}}</button>

			<button class="p-button-primary" tabindex="{{popUpTabIndex+22}}" disabled="{{checkMandatoryCondition()?'disable':''}}" class="{{checkMandatoryCondition()?'p-button-disabled':'p-button-primary'}}" id="bringOnlineLocoData" (click)="submitOperation('bringOnline')">{{configData && configData.yardLocalLabel.submit}}</button>
			</span>
        </div>
    </div>
</p-dialog>
<!-- Ends Bring Online Popup -->
<!-- Start Add Locomotive Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" [resizable]="false" [draggable]="false" class="{{errorDialog?'terminal-ui-popups add-locomotive-dialog error-dialog':'terminal-ui-popups add-locomotive-dialog'}}" header="{{popupErrorMessage}}" [(visible)]="addLocomotive" modal="true" (onHide)='cancelOperation("addLocomotive");'
    closeOnEscape="true" id="addLocomotivePopup" (onShow)="focusOnDialog('addLocomotivePopup')">
    <form #addlocomotiveForm="ngForm" novalidate (ngSubmit)='addNewLocomotive(addlocomotiveForm)' *ngIf='addLocomotive'>
        <div class="add-loco-container">

            <div class="add-loco-section">

                <div class="column-left">
                    <div class="block-view">
                        <label class="field-lables"><strong> Locomotive ID </strong> </label>
                        <div class="block-half"><input class="{{'Enter Valid Locomotive ID'===popupErrorMessage?'p-inputfield p-inputfield-error train-placeholder':'p-inputfield train-placeholder'}}" tabindex="{{popUpTabIndex+1}}" type="text" name="locomotiveIdentifier" ngModel
                                (blur)="convertLocoId()" required [(ngModel)]='addResponseError.locomotiveIdentifier' spellcheck="false"></div>
                    </div>
                </div>


            </div>


            <div class="add-loco-section">
                <div class="column-left">
                    <h2>Q- INSPECTION</h2>
                    <div class="block-view">
                        <label class="field-lables">Next Date</label>
                        <div class="block-half">
                            <lms-lms-calender [tabindex]="popUpTabIndex+2" styleClass="{{errorMap.get('nextQDateError')?'p-inputfield-error':''}}" [(ngModel)]='addResponseError.nextQDate' [minDate]='minDateValue' readonlyInput='true' name='nextQDate' ngModel [showIcon]="true" dataType="string"></lms-lms-calender>
                        </div>
                    </div>
                </div>

                <div class="column-right">
                    <h2>OTHER INSPECTION</h2>
                    <div class="block-view">
                        <label class="field-lables">Next 33 Day</label>
                        <div class="block-half">
                            <lms-lms-calender [tabindex]="popUpTabIndex+3" styleClass="{{errorMap.get('nextDailyMIDueDateError')?'p-inputfield-error':''}}" [(ngModel)]='addResponseError.nextDailyMIDueDate' [minDate]='minDateValue' readonlyInput='true' name='nextDailyMIDueDate'
                                ngModel [showIcon]="true" dataType="string"></lms-lms-calender>
                        </div>
                    </div>

                    <div class="block-view">
                        <label class="field-lables">Next Air Flow</label>
                        <div class="block-half">
                            <lms-lms-calender [tabindex]="popUpTabIndex+4" styleClass="{{errorMap.get('nextAirFlowDateError')?'p-inputfield-error':''}}" [(ngModel)]='addResponseError.nextAirFlowDate' [minDate]='minDateValue' readonlyInput='true' name='nextAirFlowDate' ngModel [showIcon]="true"
                                dataType="string"></lms-lms-calender>
                        </div>
                    </div>
                </div>
            </div>

            <div class="add-loco-section">
                <h2>CURRENT ASSIGNMENT</h2>
                <div class="column-left">
                    <div class="block-view">
                        <label class="field-lables">Assignment</label>
                        <div class="block-half">
                            <p-dropdown [panelStyleClass]="'dialog-dropdown'" [tabindex]="popUpTabIndex+5" (onChange)='changePlanOptions("Add Locomotive")' styleClass="pull-left p-dropdown" [options]="planOptions" ngModel name='currentAssignment' [(ngModel)]='locoPlannedTo'>
                                <ng-template let-planOptions>
                                    <div class="p-helper-clearfix">
                                        <div> {{planOptions.label}} </div>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                            <lms-autocomplete [inputId]='"locoDataAddLocoInput"' [tabindex]="popUpTabIndex+6" spellcheck="false" *ngIf='"terminal"===locoPlannedTo' class="{{'Enter Valid Terminal Mnemonic'===popupErrorMessage?'p-autocomplete assignment-type p-inputfield-error':'p-autocomplete assignment-type'}}"
                                id="assignmentTypeTerminal" placeholder="Mnemonic" [(ngModel)]='searchTextTerminal' ngModel name='currentUsageTerminal' [ngClass]="'terminal-autocomplete'" (onSelect)="selectValueFromAutoComplete(searchTextTerminal)" [suggestions]="filteredResults"
                                (completeMethod)="autoCompleteForTerminal($event)" [minLength]="2" [maxlength]="6" (keydown.space)='$event.stopPropagation();' (keydown.spacebar)='$event.stopPropagation();' (keyup.space)='$event.stopPropagation();' (keyup.spacebar)='$event.stopPropagation();'>
                            </lms-autocomplete>
                            <input placeholder="Train ID" tabindex="{{popUpTabIndex+6}}" *ngIf='"train"===locoPlannedTo' [(ngModel)]='searchTextTrain' id="locoDataAddLocoTrnInput" class="{{'Enter Valid Train ID'===popupErrorMessage?'train-placeholder p-inputfield assignment-type p-inputfield-error':'train-placeholder p-inputfield assignment-type'}}"
                                type="text" spellcheck="false" name="currentUsageTrain" ngModel required minlength="6" maxlength="6">
                        </div>
                        <label class="field-lables red-label">* Required</label>
                    </div>

                    <div class="block-view">
                        <label class="field-lables">Class</label>
                        <div class="block-half">
                            <p-dropdown [panelStyleClass]="'dialog-dropdown'" [tabindex]="popUpTabIndex+7" styleClass="{{errorMap.get('classError')?'pull-left p-dropdown p-inputfield-error':'pull-left p-dropdown'}}" [options]="classValue" ngModel name='clazz' [(ngModel)]='defaultClass'>
                                <ng-template let-classValue>
                                    <div class="p-helper-clearfix">
                                        <div> {{classValue.label}} </div>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </div>
                    </div>

                    <div class="block-view">
                        <label class="field-lables">HP</label>
                        <div class="block-half">
                            <input tabindex="{{popUpTabIndex+8}}" spellcheck="false" class="{{errorMap.get('horsePowerError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" name="horsePower" (keypress)="appUtilityService.isNumber($event)" [(ngModel)]='addResponseError.horsePower'
                                maxlength="4" ngModel>
                        </div>
                    </div>

                    <div class="block-view">
                        <label class="field-lables">Permanent Tag</label>
                        <div class="block-half">
                            <input tabindex="{{popUpTabIndex+9}}" spellcheck="false" type="text" [(ngModel)]='addResponseError.permanentTag' class="{{errorMap.get('permanentTagError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" name="permanentTag" ngModel maxlength="2">
                        </div>
                    </div>
                </div>

                <div class="column-right">
                    <div class="block-view">
                        <label class="field-lables">Loco Tag</label>
                        <div class="block-half">
                            <input tabindex="{{popUpTabIndex+10}}" spellcheck="false" class="{{errorMap.get('locoTagError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" name="locoTag" ngModel [(ngModel)]='addResponseError.locoTag' maxlength="2"></div>
                    </div>

                    <div class="block-view">
                        <label class="field-lables">Responsible</label>
                        <div class="block-half"> <input tabindex="{{popUpTabIndex+11}}" class="{{errorMap.get('responsibleRoadError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" name="responsibleRoad" spellcheck="false" [(ngModel)]='addResponseError.responsibleRoad'
                                ngModel maxlength="4"></div>
                    </div>

                    <div class="block-view">
                        <label class="field-lables">Direction</label>
                        <div class="block-half direction-dropdown">
                            <p-dropdown [panelStyleClass]="'dialog-dropdown'" [tabindex]="popUpTabIndex+12" styleClass="{{errorMap.get('directionFacingError')?'pull-left p-dropdown p-inputfield-error':'pull-left p-dropdown'}}" [options]="locoDirection" ngModel name='directionFacing' [(ngModel)]='defaultDirection'>
                                <ng-template let-locoDirection>
                                    <div class="p-helper-clearfix">
                                        <div> {{locoDirection.label}} </div>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </div>
                    </div>

                    <div class="block-view">
                        <label class="field-lables">Telemetry</label>
                        <div class="block-half">
                            <input tabindex="{{popUpTabIndex+13}}" spellcheck="false" class="{{errorMap.get('rduInstalledError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" name="rduInstalled" [(ngModel)]='addResponseError.rduInstalled' ngModel maxlength="1">
                        </div>
                    </div>
                </div>
            </div>
            <div class="add-loco-section no-border">
                <h2>FUEL</h2>
                <div class="column-left">
                    <div class="block-view">
                        <label class="field-lables">Avalaible Capacity</label>
                        <div class="block-half"><input tabindex="{{popUpTabIndex+14}}" spellcheck="false" class="{{errorMap.get('capacityError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" name="capacity" [(ngModel)]='addResponseError.capacity' ngModel
                                (keypress)="appUtilityService.isNumber($event)" maxlength="4"></div>
                    </div>
                    <div class="block-view">
                        <label class="field-lables">Miles to Empty</label>
                        <div class="block-half"><input tabindex="{{popUpTabIndex+15}}" spellcheck="false" class="{{errorMap.get('milesError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" name="miles" [(ngModel)]='addResponseError.miles' ngModel (keypress)="appUtilityService.isNumber($event)"
                                maxlength="4"></div>
                    </div>

                    <div class="block-view">
                        <label class="field-lables">Bulk Range</label>
                        <div class="block-half"><input tabindex="{{popUpTabIndex+16}}" spellcheck="false" class="{{errorMap.get('bulkRangeError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" name="bulkRange" [(ngModel)]='addResponseError.bulkRange' ngModel
                                (keypress)="appUtilityService.isNumber($event)" maxlength="4"></div>
                    </div>

                </div>
                <div class="column-right">
                    <div class="block-view">
                        <label class="field-lables">MFST Range</label>
                        <div class="block-half"><input tabindex="{{popUpTabIndex+17}}" spellcheck="false" class="{{errorMap.get('manifestRangeError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" [(ngModel)]='addResponseError.manifestRange' name="manifestRange"
                                ngModel (keypress)="appUtilityService.isNumber($event)" maxlength="4"></div>
                    </div>

                    <div class="block-view">
                        <label class="field-lables">Mixed Range</label>
                        <div class="block-half"><input tabindex="{{popUpTabIndex+18}}" spellcheck="false" class="{{errorMap.get('mixedRangeError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" [(ngModel)]='addResponseError.mixedRange' name="mixedRange" ngModel
                                (keypress)="appUtilityService.isNumber($event)" maxlength="4"></div>
                    </div>

                    <div class="block-view">
                        <label class="field-lables">Fuel Level</label>
                        <div class="block-half"><input tabindex="{{popUpTabIndex+19}}" spellcheck="false" class="{{errorMap.get('fuelLevelError')?'p-inputfield p-inputfield-error':'p-inputfield'}}" type="text" name="fuelLevel" [(ngModel)]='addResponseError.fuelLevel' ngModel
                                (keypress)="appUtilityService.isNumber($event)" maxlength="4"></div>
                    </div>

                </div>
            </div>
        </div>
        <div class="dialog-buttons">
            <span class="pull-right">
						<button type="button" tabindex="{{popUpTabIndex+20}}" class="p-button-secondary" (click)="cancelOperation('addLocomotive')">Cancel</button>
						<button type="submit" tabindex="{{popUpTabIndex+21}}"  id='addLocomotiveLocoData' disabled="{{('terminal'===locoPlannedTo?(addlocomotiveForm.valid && ''!=searchTextTerminal):(addlocomotiveForm.valid))  ? '' : 'disabled'}}"
						 class="{{('terminal'===locoPlannedTo?(addlocomotiveForm.valid && ''!=searchTextTerminal):(addlocomotiveForm.valid))  ? 'p-button-primary' : 'p-button-disabled'}}" >Add</button>
				</span>
        </div>
    </form>
</p-dialog>
<!-- End Add Locomotive Popup -->
<!-- Start Delete Locomotive Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" [resizable]="false" [draggable]="false" class="{{errorDialog?'terminal-ui-popups standard-dialog error-dialog':'terminal-ui-popups standard-dialog yard-local-info'}}" header="{{popupErrorMessage}}" [(visible)]="deleteLocomotive" modal="true"
    (onHide)='cancelOperation("deleteLocomotive");' closeOnEscape="true" id="locoDeletePopup" (onShow)="focusOnDialog('locoDeletePopup')">
    <div class="dialog-container" *ngIf='deleteLocomotive'>
        <span>Are you sure you want to delete the locomotive <strong>{{tab.tabSearchParameter.searchText}}</strong> ?</span>
    </div>
    <div class="dialog-buttons" *ngIf='deleteLocomotive'>
        <span class="pull-right">
								<button tabindex="{{popUpTabIndex+1}}" type="button"  class="p-button-secondary" (click)="cancelOperation('deleteLocomotive')">No</button>
								<button tabindex="{{popUpTabIndex+2}}"type="button"  id='deleteLocomotiveLocoData' class="p-button-primary" (click)="deleteExistingLocomotive()">Yes</button>
							</span>
    </div>
</p-dialog>
<!-- END Delete Locomotive Popup -->
<!-- Start Yard and Local Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" [resizable]="false" [draggable]="false" class="{{errorDialog?'terminal-ui-popups error-dialog':'terminal-ui-popups yard-local-info'}}" header="Yard and Local" [(visible)]="yardAndLocal" modal="true" (onHide)='cancelOperation("yardAndLocal");'
    closeOnEscape="true" id="locoYardLocalPopup" (onShow)="focusOnDialog('locoYardLocalPopup')">
    <div class="dialog-container" *ngIf='yardAndLocal'>
        <span>The locomotive is allocated to Yard and Local service. Screen for Yard and Local will be available in one of the future releases.</span>
    </div>
    <div class="dialog-buttons" *ngIf='yardAndLocal'>
        <span class="pull-right">
			<button type="button" tabindex="{{popUpTabIndex+1}}"  id='yardAndLocalLocoData' (click)="cancelOperation('yardAndLocal')" class="p-button-primary">OK</button>
		</span>
    </div>
</p-dialog>
<!-- END Yard and Local Popup -->

<!-- Start Rule Exception Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id='locoDataRuleExceptionId' [resizable]="false" [draggable]="false" class="terminal-ui-popups rule-exceptions" header="Rules Warning" [(visible)]="ruleException" modal="true" (onHide)='cancelOperation("ruleException");' (onShow)='setPageMode("ruleExceptionLocoData","locoDataRuleExceptionId");'
    closeOnEscape="true" id="locoRuleExceptionPopup">
    <div class="bre-dialog-header">
        <div class="plan-to-dropdown">
            <label class="pull-left block-32">Plan to Train</label>
            <span class="loco-tag">{{searchTextTrain ? searchTextTrain.toUpperCase() : '-'}}</span>
        </div>

    </div>
    <div class="exception-reason">
        <span class="exception-icon"></span>
        <div class="exception-details">
            <span class="color-red">Exception with {{(lmsExceptionList && lmsExceptionList.length > 1) ? lmsExceptionList.length : '' }} Planned {{(lmsExceptionList
			&& lmsExceptionList.length > 1) ? 'Locomotives' : 'Locomotive' }}</span>
            <p class="info-text">To <span>Override Rule</span>,{{(lmsExceptionList && lmsExceptionList.length > 1) ? ' Select Loco and hit submit. Unselected Loco will be auto cancelled.': ' add Reason and hit submit.' }}</p>
        </div>

    </div>
    <div class="exceptions-tbl-head">

        <span class="locomotive-head">LOCOMOTIVE</span>
        <span class="exception-intended-usage-head">INTENDED USAGE INFO</span>
        <span class="exception-info-head">WARNING</span>

    </div>
    <div class="exception-dialog" *ngIf='ruleException'>
        <div class="exception-list">
            <div class="exception-rows" *ngFor='let lException of lmsExceptionList; let i = index'>
                <lms-bre-exception [lmsException]='lException' (checkCheckedLoco)="checkCheckedLoco()" [tabLevel]="popUpTabIndex+15"></lms-bre-exception>
            </div>
        </div>
    </div>
    <div class="dialog-buttons" *ngIf='ruleException'>
        <span class="pull-right">
								<button type="button" tabindex="{{popUpTabIndex+125}}" class="p-button-secondary" (click)="cancelOperation('ruleException')">Cancel</button>
								<button type="button" tabindex="{{popUpTabIndex+126}}" id='ruleExceptionLocoData' [ngClass]="isRuleExceptionSubmitEnabled? 'p-button-primary' : 'p-button-secondary p-button-disabled'" disabled="{{isRuleExceptionSubmitEnabled? '' : 'disabled'}}" (click)="ruleExceptionSubmit(popUpTypeBre)">Submit</button>
							</span>
    </div>
</p-dialog>
<!-- END Rule Exception Popup -->
